import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  submit(event) {
    event.preventDefault();
    const form = event.target.closest("form");
    const token = document.querySelector('meta[name="csrf-token"]')?.content;

    fetch(form.action, {
      method: form.method || "POST",
      headers: { "X-CSRF-Token": token },
      body: new FormData(form),
    });
  }
}
